(() => {
  'use strict';
  const root = document.documentElement;
  const data = document.getElementById('vclot-mode-images');
  if (!data || root.dataset.vclotImagesReady) return;
  root.dataset.vclotImagesReady = 'true';
  const products = JSON.parse(data.textContent);
  const originals = new WeakMap();
  const targets = new WeakMap();
  const galleryStates = new Map();
  const replacements = new Map();
  for (const entry of Object.values(products)) {
    for (const [filename, view] of Object.entries(entry.sources)) {
      replacements.set(filename, entry[view]);
    }
  }
  const attributes = ['src', 'srcset', 'sizes', 'alt'];
  const filename = (src) => {
    try { return decodeURIComponent(new URL(src, location.href).pathname.split('/').pop()); }
    catch { return ''; }
  };
  function restore(image) {
    const saved = originals.get(image);
    if (!saved) return;
    for (const name of attributes) {
      if (saved[name] === null) image.removeAttribute(name);
      else image.setAttribute(name, saved[name]);
    }
    originals.delete(image);
    targets.delete(image);
    image.removeAttribute('data-vclot-dark-image');
  }
  function replace(image, src, alt) {
    if (!originals.has(image)) {
      originals.set(image, Object.fromEntries(attributes.map(name => [name, image.getAttribute(name)])));
    }
    const url = new URL(src, location.href);
    url.searchParams.set('width', '1200');
    targets.set(image, filename(src));
    if (image.getAttribute('src') === url.href && image.hasAttribute('data-vclot-dark-image') && (image.getAttribute('srcset') || '').includes(filename(src))) return;
    image.setAttribute('data-vclot-dark-image', 'true');
    image.setAttribute('srcset', [360, 720, 1200, 1600].map(width => {
      const candidate = new URL(src, location.href);
      candidate.searchParams.set('width', String(width));
      return `${candidate.href} ${width}w`;
    }).join(', '));
    image.src = url.href;
    if (alt) image.alt = alt;
  }
  function run() {
    queued = false;
    const dark = root.getAttribute('data-vclot-mode') === 'dark';
    if (!dark) {
      document.querySelectorAll('img[data-vclot-dark-image]').forEach(restore);
      for (const [gallery, state] of galleryStates) {
        for (const [slide, saved] of state.slides) {
          slide.hidden = saved.hidden;
          if (saved.reveal === null) slide.removeAttribute('reveal');
          else slide.setAttribute('reveal', saved.reveal);
        }
        gallery.querySelector('slideshow-component')?.select(0, undefined, { animate: false });
      }
      galleryStates.clear();
      return;
    }
    const cardImages = new Set();
    for (const gallery of document.querySelectorAll('.card-gallery')) {
      const link = gallery.querySelector('a[href*="/products/"]');
      const handle = link?.getAttribute('href').split('/products/')[1]?.split(/[?#/]/)[0];
      const entry = products[handle];
      if (!entry) continue;
      const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
      let state = galleryStates.get(gallery);
      if (!state || slides.some(slide => !state.slides.has(slide))) {
        const visible = slides.filter(slide => !slide.hidden);
        const front = slides.find(slide => {
          const image = slide.querySelector('img');
          const source = originals.get(image)?.src || image?.getAttribute('src');
          return entry.sources[filename(source)] === 'front';
        }) || visible[0] || slides[0];
        const back = slides.find(slide => {
          const image = slide.querySelector('img');
          const source = originals.get(image)?.src || image?.getAttribute('src');
          return entry.sources[filename(source)] === 'back';
        }) || visible[1];
        state = {
          slides: new Map(slides.map(slide => [slide, { hidden: slide.hidden, reveal: slide.getAttribute('reveal') }])),
          front,
          back,
          reset: true
        };
        galleryStates.set(gallery, state);
      }
      for (const slide of slides) {
        slide.hidden = slide !== state.front && slide !== state.back;
        if (slide.hidden) slide.removeAttribute('reveal');
      }
      const images = Array.from(gallery.querySelectorAll('img'));
      images.forEach(image => {
        if (!image) return;
        cardImages.add(image);
        const slide = image.closest('slideshow-slide');
        const source = originals.get(image)?.src || image.getAttribute('src');
        const mappedView = entry.sources[filename(source)];
        const view = slide === state.front ? 'front' : slide === state.back ? 'back' : mappedView || 'front';
        const title = link.getAttribute('aria-label') || '';
        replace(image, entry[view], `Black | ${title}, ${view} view`);
      });
      if (state.reset) {
        state.reset = false;
        gallery.querySelector('slideshow-component')?.select(0, undefined, { animate: false });
      }
    }
    for (const image of document.querySelectorAll('img')) {
      if (cardImages.has(image)) continue;
      const original = originals.get(image);
      const src = original?.src || image.getAttribute('src');
      const target = replacements.get(filename(src));
      if (target) replace(image, target);
    }
  }
  let queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  }
  new MutationObserver(queue).observe(root, { attributes: true, attributeFilter: ['data-vclot-mode'] });
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' || (record.target instanceof HTMLImageElement && (!record.target.hasAttribute('data-vclot-dark-image') || (targets.has(record.target) && (filename(record.target.getAttribute('src')) !== targets.get(record.target) || !(record.target.getAttribute('srcset') || '').includes(targets.get(record.target)))))))) queue();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  document.addEventListener('shopify:section:load', queue);
  window.addEventListener('pageshow', queue);
  queue();
})();

